export enum Actions {
    CancelRequest = 5,
    MarkReceived = 10,
    MarkReceivedBack = 15,
    RequestUpdate = 20,
    TrackPackage = 30,
    MarkRemoteShipped = 40,
    DonorBloodDrawnShipped = 50,
    MarkShippedOut = 55,
    MarkShippedBack = 60,
    RecordResults = 70,
    DonorHlaFile = 80,
    DonorCtReport = 90,
    DonorMedicalChart = 100,
    UploadFinalXm = 110
}
